var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"public-layout",attrs:{"id":"inspire"}},[(!_vm.routesWithoutTopbar)?_c('PublicTopbar'):_vm._e(),_vm._v(" "),_c('v-main',{staticClass:"public-layout__wrapper"},[_c('nuxt'),_vm._v(" "),(_vm.showApplyButton)?_c('deck-button',{staticClass:"public-layout__apply-button",attrs:{"size":"large","text":_vm.$t('apply'),"to":_vm.localePath({
        name: 't-tenantSlug-sign-up',
        params: {
          tenantSlug: _vm.$route.params.tenantSlug,
        },
      })}}):_vm._e()],1),_vm._v(" "),_c('Snackbar',{attrs:{"is-public":""}}),_vm._v(" "),_c('TheDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }